// Vendors
import $ from 'jquery';
import raf from 'raf';

import { oktaAuthClient, requestMFA } from './okta-login';

const gated = $('[data-gated]');
if (gated.length && gated.data('gated') === 'article') {
  const background = gated.find('.gated__background');
  const modal = gated.find('.gated__modal');
  const opacityStart = Number(background.css('opacity'));
  const opacityEnd = 1;

  const fadeBackground = () => {
    const backgroundOffset = background.offset().top;
    const windowHeight = window.innerHeight;
    const offsetTop = window.pageYOffset - backgroundOffset + windowHeight;

    if (offsetTop < 0) {
      return;
    } else if (offsetTop > 500) {
      modal.addClass('gated__modal--visible');
    } else {
      modal.removeClass('gated__modal--visible');
    }

    const backgroundOpacity = Math.abs(
      (offsetTop / 1000) * (opacityStart - opacityEnd)
    );

    raf(() => {
      background.css('opacity', backgroundOpacity);
    });
  };

  $(window).on('scroll', () => fadeBackground());
  fadeBackground();
}

// Article form
$('#gated-article-form').on('submit', (event) => {
  event.preventDefault();
});

// PIP, FIP, FSA Login
$('#pip-login, #fip-login, #fsa-login').on('click', (event) => {
  event.preventDefault();
  gated.removeClass('gated--hidden');
});

// Close Modal
gated.find('[data-modal-close]').on('click', (event) => {
  event.preventDefault();
  gated.addClass('gated--hidden');
});

// Gated Login Functionality
let currentTransaction; // Used to share information into MFA scope

$('#gated-resource-form').on('submit', (event) => {
  event.preventDefault();

  const $submitBtn = $('#gated-resource-form__submit-btn');
  const email = $.trim($('#gated-resource-form input[name=email]').val());
  const password = $.trim($('#gated-resource-form input[name=password]').val());
  const data = $('#gated-resource-form').serialize();

  $submitBtn.addClass('btn--loading');

//As of 2025-02-04 removing add to cart redirect functionality based on Content request. User now gets prompted to login on page load, and after login gets redirect to same product page to view (removed download and cart add triggers):
  oktaAuthClient &&
    oktaAuthClient
      .signInWithCredentials({
        username: email,
        password: password
      })
      .then(function (transaction) {
        if (transaction.status === 'SUCCESS') {
          $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php?action=gated_login',
            dataType: 'json',
            data: data,
            success: function (response) {
              $submitBtn.removeClass('btn--loading');

              if (response.data.error) {
                $('.notice--error .error').html(response.data.error);
                $('.notice--error').show();
              } else {
                if (
                  response.data.post_type &&
                  response.data.redirect_to
                ) {
                  oktaAuthClient.session.setCookieAndRedirect(
                    transaction.sessionToken,
                    response.data.redirect_to
                  );
                  return;
                }
              }
            },
            error: function (jqXHR, exception) {
              $submitBtn.removeClass('btn--loading');
            }
          });
        } else if (transaction.status === 'MFA_REQUIRED') {
          currentTransaction = transaction;

          requestMFA(transaction).then((_) => {
            $submitBtn.removeClass('btn--loading');

            $('#gated-resource-form').hide();
            $('.gated__modal-title').text('Multi-Factor Authentication');
            $('.notice--error .error').html(
              "A verification code has been sent to user's email"
            );
            $('.notice--error').show();
            $('#gated-mfa-form').show();
          });
        } else {
          $submitBtn.removeClass('btn--loading');
          throw 'We cannot handle the ' + transaction.status + ' status';
        }
      })
      .catch(function (err) {
        console.error(err);

        $('.notice--error .error').html(err.message);
        $('.notice--error').show();

        $submitBtn.removeClass('btn--loading');
      });
});

// Gated Multifactor Authentication
$('#gated-mfa-form').on('submit', (event) => {
  event.preventDefault();

  const { factors } = currentTransaction;
  const data = $('#gated-resource-form').serialize();
  const verificationCode = $.trim(
    $('#gated-mfa-form input[name=verification]').val()
  );
  const $submitBtn = $('.gated-mfa-form__submit button.btn');

  $submitBtn.addClass('btn--loading');

  $.ajax({
    type: 'POST',
    xhrFields: { withCredentials: true },
    url: '/wp-admin/admin-ajax.php?action=wl_authenticate_mfa',
    dataType: 'json',
    data: {
      url: `/api/v1/authn/factors/${factors[0].id}/verify`,
      passCode: verificationCode,
      stateToken: currentTransaction.data.stateToken
    },
    success: (transaction) => {
      if (transaction.data.status === 'SUCCESS') {
        $.ajax({
          type: 'POST',
          url: '/wp-admin/admin-ajax.php?action=gated_login',
          dataType: 'json',
          data: data,
          success: function (response) {
            if (response.data.error) {
              $('.notice--error .error').html(response.data.error);
              $('.notice--error').show();
            } else {
              if (
                response.data.post_type &&
                response.data.redirect_to
              ) {
                window.location.href = response.data.redirect_to;
                return;
              }
            }
          },
          error: function (jqXHR, exception) {}
        });
      } else {
        $submitBtn.removeClass('btn--loading');

        $('.notice--error .error').html(
          'The verification code you entered is incorrect'
        );
        $('.notice--error').show();

        console.error(transaction.data.errorSummary);
      }
    }
  }).catch((err) => {
    $('.notice--error').show();
    $('.notice--error .error').html(
      'The verification code you entered is incorrect'
    );
    console.error(err);
  });
});
